import {Injectable} from "@angular/core";
import {AuthApiService} from "./auth-api.service";
import {UserData} from "./user.data";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class UserService {

    constructor(private http: HttpClient, private auth: AuthApiService) {
    }

    async getLoggedUser(): Promise<UserData> {
        return firstValueFrom(this.http.get<UserData>("/fonzie/loggedUser", {headers: this.auth.getHttpHeaderOptions()}));
    }
}
